<div class="page__header">
    <custom-app-bar
            [hasBackButton]="true"
            (onClickBackButton)="previous()"
            [backButtonReturnToThePreviousPage]="false"
    >
    </custom-app-bar>
</div>
<div [ngTemplateOutlet]="selected ? selected.content : null"></div>


